import { useParams, useNavigate, Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import ContactDetails from '../contact/ContactDetails';
import ClientView from '../client/ClientView';
import DocumentDetails from '../DocumentDetails';
import { Container, Card, Tabs, Tab, Button } from 'react-bootstrap';
import { BiPencil } from "react-icons/bi";
import { BsChevronLeft } from "react-icons/bs";
const VendorDetails = ({ type }) => {
    const { id } = useParams(); // Get instance ID from the URL
    const navigate = useNavigate();
    const [VendorDetails, setVendorDetails] = useState(null);
    const [activeTab, setActiveTab] = useState('vendorDetails');
    const [showModal, setShowModal] = useState(false);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const didFetchRef = useRef(false); // Use ref to track whether the API has been called

    // Function to fetch instance details
    const fetchVendorDetails = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/contacts/${id}?type=${type}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
            });
            console.log(response.data); // Check the data structure

            setVendorDetails(response.data.Data); // Set the fetched data to state
        } catch (error) {
            console.error('Error fetching instance details:', error);
        }
    };

    useEffect(() => {
        if (!didFetchRef.current) {
            fetchVendorDetails(); // Only fetch data if it hasn't been done before
            didFetchRef.current = true; // Mark that data has been fetched
        }
    }, [id]); // This will run only when `id` changes

    // Handle back button click
    const handleBackClick = () => {
        navigate(-1);
    };
    const [refreshKey, setRefreshKey] = useState(0);

    const handleAvatarUpdate = (newAvatarUrl) => {
        console.log("New Avatar URL:", newAvatarUrl);

        setVendorDetails((prevDetails) => ({
            ...prevDetails,
            avatar: newAvatarUrl,
        }));

        setRefreshKey(prev => prev + 1); // Force re-render
    };
    // Handle tab click to change active tab
    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    {/* Page Title */}
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0  d-flex align-items-center">
                                    <BsChevronLeft
                                        className='back-button1'
                                        onClick={() => navigate(-1)}
                                    />
                                    <span>{`${type.charAt(0).toUpperCase() + type.slice(1)} Details`}</span>
                                </h4>
                                <div className="page-title-right br-font">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item"> <Link to={`/contacts/${type}/details/${id}`}>
                                            {VendorDetails?.name || `${type.charAt(0).toUpperCase() + type.slice(1)} Details`}
                                        </Link></li>
                                        <li className="breadcrumb-item active">Details</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="p-6 max-w-7xl mx-auto">
                        <>
                            <div className="row">
                                <div className="col-md-10">

                                    <Card className="mb-4 shadow-lg rounded-3 p-3 border-0 card-bg">
                                        {/* Header Section with Name and Edit Icon */}
                                        <div className="d-flex justify-content-between align-items-center">
                                            <Card.Title className="fw-bold font-size-14 text-primary">{VendorDetails?.name}</Card.Title>
                                            
                                        </div>
                                        <Card.Body className="pt-3">
                                            <div className="row">
                                                {/* Left Section */}
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <span className="text-muted d-block card-label"><strong>Bussiness:</strong></span>
                                                        <span className=" text-muted card-value">{VendorDetails?.business_name || '-'}</span>
                                                    </div>
                                                    <div className="mb-3">
                                                        <span className="text-muted d-block card-label"><strong>Email:</strong></span>
                                                        <span className=" text-muted card-value">{VendorDetails?.email || '-'}</span>
                                                    </div>
                                                </div>

                                                {/* Right Section */}
                                                <div className="col-md-4">
                                                    <div className="mb-3">
                                                        <span className="text-muted d-block card-label"><strong>Address:</strong></span>
                                                        <span className="fw-semibold text-primary card-vale">{VendorDetails?.Address || ''}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </div>
                                <div className="col-md-2">
                                    <Card className="text-center shadow-lg rounded-3 p-2 border-0">
                                        <Card.Body>
                                            <div className="d-flex justify-content-center11 mb-2">
                                                {VendorDetails?.avatar ? (
                                                    <img
                                                        src={`${process.env.REACT_APP_BACKEND_URL}/storage/${VendorDetails.avatar}`}
                                                        alt="Client Avatar"
                                                        className="rounded-circle img-circle"
                                                    />
                                                ) : (
                                                    <div className="rounded-circle d-flex align-items-center justify-content-center bg-primary text-white fw-bold img-circle">
                                                        {VendorDetails?.name ? VendorDetails.name.charAt(0).toUpperCase() : "?"}
                                                    </div>
                                                )}
                                            </div>

                                            <h5 className="fw-bold text-dark font-size-14 ">{VendorDetails?.name || "N/A"}</h5>
                                            <p className="text-muted font-size-13">{VendorDetails?.business_name || "N/A"}</p>
                                        </Card.Body>

                                        <div className="contact-links d-flex justify-content-around font-size-17">
                                            <a href="#" className="text-dark"><i className="bx bx-message"></i></a>
                                            <a href="#" className="text-dark"><i className="bx bx-phone"></i></a>
                                            <a
                                                href="#"
                                                className="text-dark"
                                                onClick={(e) => {
                                                    e.preventDefault(); // Prevent default anchor behavior
                                                    handleTabClick("VendorDetails"); // Switch to client details tab
                                                }}
                                            >
                                                <i className="bx bx-user-circle"></i>
                                            </a>                    </div>

                                    </Card>
                                </div>
                            </div>
                        </>
                        <div className="row">
                            <div className="col-xl-12 col-lg-8">
                                <div className="card">
                                    {/* Nav tabs */}
                                    <ul className="nav nav-tabs nav-tabs-custom justify-content-start pt-2 font-size-13" role="tablist">

                                        <li className="nav-item">
                                            <a
                                                className={`nav-link ${activeTab === 'vendorDetails' ? 'active' : ''}`}
                                                onClick={() => handleTabClick('vendorDetails')}
                                                role="tab"
                                            >
                                                Vendor Details
                                            </a>
                                        </li>

                                    </ul>
                                    <div className="tab-content p-4">

                                        {activeTab === "vendorDetails" && VendorDetails && (
                                            <div className="tab-pane active" id="instacne-list" role="tabpanel">
                                                <div className="p-3">
                                                    <ClientView data={VendorDetails} type={type} clientId={id} setVendorDetails={setVendorDetails} onAvatarUpdate={handleAvatarUpdate} />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>

    );
};

export default VendorDetails;
